// extracted by mini-css-extract-plugin
export default {"ctn":"battery_ctn__2uywj","textBox":"battery_textBox__bwZKu","paramsBox":"battery_paramsBox__2+xFq","imgBox":"battery_imgBox__KDrHc"};